import { useAtom } from "jotai";
import { useFieldArray, useFormContext } from "react-hook-form";

import { useCrefazCltContext } from "@/app/hooks/useCrefazCltContext";
import { currentStep } from "@/app/store";
import { phoneMask } from "@/app/utils/phoneFormater";
import { BasicInput } from "@/view/components/BasicInput";
import { BasicSelect } from "@/view/components/BasicSelect";
import { Button } from "@/view/components/ui/button";

interface ReferencesFormProps {
  visible?: boolean;
}

export default function ReferencesForm({ visible }: ReferencesFormProps) {
  const [, setStep] = useAtom(currentStep);

  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "referencias.contatos",
  });

  const { items: degrees } = useCrefazCltContext("tipoReferencia");

  const degreeOptions = degrees.map((degree) => ({
    label: degree.nome,
    value: String(degree.id),
  }));

  const referenceErrors = (errors.referencias as any)?.contatos;

  const handleNext = async () => {
    const isValid = await trigger("referencias");

    if (isValid) setStep((state) => state + 1);
  };

  return (
    <div className={visible ? "flex flex-col gap-8" : "hidden"}>
      <div className="flex flex-col gap-6">
        {fields.map((field, index) => (
          <div key={field.id} className="grid grid-cols-1 gap-4 lg:grid-cols-3">
            <BasicSelect
              name={`referencias.contatos.${index}.grau`}
              label="Grau de parentesco"
              options={degreeOptions}
              placeholder="Selecione"
              error={referenceErrors?.[index]?.grau?.message}
            />
            <BasicInput
              name={`referencias.contatos.${index}.nome`}
              label="Nome"
              error={referenceErrors?.[index]?.nome?.message}
            />
            <BasicInput
              name={`referencias.contatos.${index}.telefone`}
              label="Telefone"
              onInput={phoneMask}
              maxLength={15}
              error={referenceErrors?.[index]?.telefone?.message}
            />
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-5">
        <Button
          type="button"
          className="rounded-full bg-white02 px-8 py-3 font-semibold text-primary hover:bg-white02"
          onClick={() => setStep((state) => state - 1)}
        >
          Voltar
        </Button>
        <Button
          type="button"
          className="rounded-full px-8 py-3 font-semibold text-white"
          onClick={handleNext}
        >
          Continuar
        </Button>
      </div>
    </div>
  );
}
